<template>
  <div class="order-list">
    <van-nav-bar title="账户流水" left-text="返回" left-arrow @click-left="$router.push('/admin')" >
      <template #right>
        <van-dropdown-menu active-color="#1989fa" >
          <van-dropdown-item v-model="moneyType" :options="moneyTypeOption" @change="filterOrder"/>
        </van-dropdown-menu>
      </template>
    </van-nav-bar>

    <van-tabs v-model="periodType" @click="pushRefresh">
      <van-tab v-for="index in 7" :key="index">
        <template #title>{{tab[index-1]}}<font color="red">({{moneyLogCounts[index-1]}})</font></template>
      </van-tab>
    </van-tabs>
    <div style="margin-top:10px">
      <van-pull-refresh v-model="refreshing" @refresh="pushRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getMoneyLog">
          <van-cell-group  v-for="item in moneyLogList"
                           :key="item.id">
            <van-divider
                    :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }"
            >
              {{item.wxUser.nickName}}({{item.wxUser.inviteCode}})
            </van-divider>
            <van-cell :value="item.addType+` 金额:`+formatPrice(item.money)+`元`" :label="`变动前:`+formatPrice(item.beforeMoney)+` 变动后:`+formatPrice(item.afterMoney)">
              <!-- 使用 title 插槽来自定义标题 -->
              <template #title>
                <span class="custom-title" style="margin-right:20px">{{getDate(item.createTime)}}</span>
                <van-tag :type="item.type == 'WITHDRAW'?'danger':'success'" >{{item.typeText}}</van-tag>
              </template>
            </van-cell>
          </van-cell-group>
        </van-list>
      </van-pull-refresh>
      <no-data v-if="moneyLogList.length == 0 && !loading"></no-data>
    </div>
  </div>
</template>


<script>
import { Divider, Icon, Cell, CellGroup, NavBar, Button, Card, Tag ,Tab, Tabs, Panel, PullRefresh,DropdownMenu,DropdownItem, Collapse, CollapseItem} from "vant";
import NoData from "@/components/NoData";
import fetch from '../../libs/fetch'
import {Dialog} from 'vant'
export default {
  components: {
    [NavBar.name]: NavBar,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Card.name]: Card,
    [Tag.name]: Tag,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Panel.name]: Panel,
    [PullRefresh.name]: PullRefresh,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Divider.name]: Divider,

    NoData
  },
  data() {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      moneyLogList: [],
      page: {
        pageNum: 1,
        pageSize: 20
      },
        tab:[
            '所有',
            '上月',
            '本月',
            '上周',
            '本周',
            '昨天',
            '今天',
        ],
      moneyType: '',
      moneyTypeOption: [
          { text: '所有', value: '' },
          { text: '首单奖励', value: 'FIRST' },
          { text: '美团佣金', value: 'mt' },
          { text: '饿了吗佣金', value: 'ele' },
          { text: '肯德基佣金', value: 'kfc' },
          { text: '商城佣金', value: 'mall' },
          { text: '提现', value: 'WITHDRAW' },
      ],
      periodType: '3',
      moneyLogCounts: [0,0,0,0,0,0,0],

    };
  },
  mounted() {},
  computed: {},
  methods: {
    pushRefresh() {
      this.loading = true
      this.moneyLogList = []
      this.page.pageNum = 1
      this.getMoneyLog()
      this.finished = false
    },
    getMoneyLogCounts() {
      for (var i=0;i<7;i++){
        this.getMoneyLogCount(i)
      }
    },
      getMoneyLogCount(periodType) {
      // 获取订单
          const openId = localStorage.getItem('openId')
      let url = '/pdd-user/public/pay/moneylog?operOpenId=' + openId+"&type="+this.moneyType+"&periodType="+periodType+"&pageSize="+this.page.pageSize+"&pageNum=1";

      fetch({
          url: url,
          method: 'get'
      }).then(response => {
        this.moneyLogCounts[periodType] = response.data.total
      }).catch(error => {
          console.log(error)
          Dialog.alert({
              title: '系统提示',
              message: error
          }).then(() => {
              // on close
          })
      });
    },
    getMoneyLog() {
      this.getMoneyLogCounts()
       // 获取账户流水
      const openId = localStorage.getItem('openId')
      let url = '/pdd-user/public/pay/moneylog?operOpenId=' + openId+"&type="+this.moneyType+"&periodType="+this.periodType+"&pageSize="+this.page.pageSize+"&pageNum="+this.page.pageNum;
      
      fetch({
          url: url,
          method: 'get'
      }).then(response => {
          let totalPage = Math.floor(response.data.total/this.page.pageSize) + 1
          if(totalPage == this.page.pageNum){
              this.finished = true
          } else {
            this.page.pageNum++
          }
          this.moneyLogList = this.moneyLogList.concat(response.data.list);
          this.loading = false
          this.refreshing = false
      }).catch(error => {
          console.log(error)
          Dialog.alert({
              title: '系统提示',
              message: error
          }).then(() => {
              // on close
          })
          this.loading = false
          this.refreshing = false
      });
    },
    getDate(date_str) {
      return date_str.split(".")[0].replace("T"," ");
    },
    formatPrice(money) {
      if (money) {
        let _money = Math.ceil(Number(money)) / 100;
        return _money;
      } else {
        return 0;
      }
    },
   
    filmOrderStatus(type){
        if(type == 0){
            return '待付款'
        }else if(type == 5){
            return '待出票'
        }else if(type == 10){
            return '已出票'
        }else if(type == 15){
            return '交易成功'
        }else if(type == -5){
            return '已取消'
        }

    },
      
    filterOrder(){
        this.pushRefresh()
    }
  },
  filters: {
    // formatPrice(money) {
    //   return money.toFix(2)
    // }
  }
};
</script>

<style lang="less">
.order-list {
  z-index: 1000;
  padding-bottom: 55px;
  background-color: #f8f8f8;
  p {
    margin: 0;
  }
}
.custom-title {
  font-size: 12px;
}
.custom-value{
  font-size: 10px;
}
.van-dropdown-menu__bar{
  box-shadow: none;
}
.van-tabs__line{
  z-index: 0;
}
.van-cell{
  padding-top: 5px;
  padding-bottom: 5px;

}
</style>
